import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MicrosoftAttributes, MicrosoftAttributesFieldConfig } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class MicrosoftOnPremAdResource {
  private http = inject(HttpClient);

  getOnPremAttributesFieldConfig(
    tenantId: string | number,
    did: string,
    extension?: string,
  ): Observable<MicrosoftAttributesFieldConfig> {
    const params = new URLSearchParams(
      extension
        ? {
            did,
            ext: extension,
          }
        : { did },
    );
    const path = `/services/microsoft/teams-user-management/tenants/${tenantId}/field-configs/on-prem-ad-attributes?${params.toString()}`;

    return this.http.get<MicrosoftAttributesFieldConfig>(path);
  }

  getAdAttributes(tenantId: string | number, upn: string, dialPlanId: number): Observable<MicrosoftAttributes> {
    return this.http.get<MicrosoftAttributes>(
      `/services/microsoft/macs/tenants/${tenantId}/on-prem-ad-attributes/${upn}/dial-plans/${dialPlanId}`,
    );
  }

  putAdAttributes(
    tenantId: string | number,
    upn: string,
    dialPlanId: number,
    body: MicrosoftAttributes,
  ): Observable<void> {
    return this.http.put<void>(
      `/services/microsoft/macs/tenants/${tenantId}/on-prem-ad-attributes/${upn}/dial-plans/${dialPlanId}`,
      body,
    );
  }
}
